import { noop, queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { Type } from "typebox";
import * as TypeCompiler from "typebox/compile";
import {
  Nullable,
  ReadonlyArray,
  ReadonlyObject,
} from "@/shared/schema/schema.ts";
import { httpChecked } from "@/shared/util/fetch.ts";
import { queryClient } from "@/shared/util/queryClient.tsx";

const ImpersonationUsers = ReadonlyArray(
  ReadonlyObject({
    id: Type.String(),
    name: Nullable(Type.String()),
    email: Type.String(),
  }),
);

const checker = TypeCompiler.Compile(ImpersonationUsers);

const queries = {
  list: queryOptions({
    queryKey: ["impersonation-users"] as const,
    queryFn: ({ signal }) =>
      httpChecked.get("/session/admin/users", checker, { signal }),
  }),
};

export function useImpersonationUsers() {
  const { data } = useSuspenseQuery({ ...queries.list, staleTime: 60_000 });

  return data;
}

export async function prefetchImpersonationUsers() {
  // eslint-disable-next-line unicorn/prefer-await
  await queryClient.query({ ...queries.list, staleTime: Infinity }).catch(noop);
}
